import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import { Sidebar } from '@blockpulse3/web-client/sidebar';

type Props = unknown;

export function AppLayout(): JSX.Element {
  return (
    <Flex as="section" direction={{ base: 'column', lg: 'row' }} height="auto" minH="100vh">
      <Sidebar />
      <Box w="64" />
      <Box bg="gray.50" flex="1" overflowY="auto" px={{ base: '4', md: '8' }} py="6">
        <Outlet />
      </Box>
    </Flex>
  );
}

export type AppLayoutProps = Props;
